import React from "react"
import { StaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"


const AndreaGoldImage = () => (
  <StaticQuery
    query={graphql`
      query {
        placeholderImage: file(relativePath: { eq: "Andrea_gold_Shadow.png" }) {
          childImageSharp {
            fluid(maxWidth: 900) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    `}
    render={data => <Img  fluid={data.placeholderImage.childImageSharp.fluid} />}
  />
)
export default AndreaGoldImage
